import type { ReactNode } from "react";

const FONT_STYLE = { fontFamily: "'Montserrat', sans-serif" } as const;

interface PageShellProps {
  children: ReactNode;
  className?: string;
}

/**
 * Wraps every page with the standard Montserrat font.
 * Usage: <PageShell className="space-y-6">{content}</PageShell>
 */
export function PageShell({ children, className = "" }: PageShellProps) {
  return (
    <div className={className} style={FONT_STYLE}>
      {children}
    </div>
  );
}
